import {
  Stack,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';

export const InsidePageContainer = styled(Stack)({
  padding: '0px 15px',
  [`@media (min-width: 768px)`]: {
    margin: '0 auto',
    width: '750px',
  },
  [`@media (min-width: 992px)`]: {
    width: '970px',
  },
  [`@media (min-width: 1280px)`]: {
    width: '1280px',
  },
});

export const AlignedPageContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  minHeight: 'calc(100vh - 600px)',
  height: '100%',
  padding: '30px 0px',
  gap: '20px',
  [`@media (min-width:${theme.breakpoints.values.lg}px)`]: {
    padding: '60px 0px',
    gap: '40px',
  },
}));

export const WhitePageContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: 'white',
  padding: '30px 0px',
  gap: '20px',
  [`@media (min-width:${theme.breakpoints.values.lg}px)`]: {
    padding: '40px 0px',
    gap: '25px',
  },
}));

export const WhitePageContainerFlex = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: 'white',
  padding: '30px 0px',
  gap: '20px',
  marginBottom: '20px',
  [`@media (min-width:${theme.breakpoints.values.lg}px)`]: {
    padding: '40px 0px',
    gap: '25px',
    marginBottom: '50px',
  },
}));
export const StyledTab = styled(Typography)(({ theme, isSelected }) => ({
  width: '50%',
  padding: '15px 0px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderBottom: isSelected
    ? `2px solid ${theme.palette.primary.main}`
    : `2px solid ${theme.palette.grey[200]}`,
}));
export const StyledTabAnalytics = styled(Typography)(
  ({ theme, isSelected }) => ({
    padding: '15px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderBottom: isSelected
      ? `2px solid ${theme.palette.primary.main}`
      : `2px solid ${theme.palette.grey[200]}`,
  })
);

export const AskForInfoCard = styled(Stack)(({ theme }) => ({
  width: '100%',
  padding: '20px',
  gap: '15px',
  border: '1px solid #E1E1E1',
  backgroundColor: 'white',
  [`@media (min-width:${theme.breakpoints.values.lg}px)`]: {
    padding: '40px',
    gap: '20px',
    maxWidth: '450px',
  },
}));

export const RedLinkButton = ({
  onClick,
  msg,
  leftIcon = null,
  rightIcon = null,
  hideTextOnMobile = false,
  customStyle = {},
  variant = 'link1',
  disabled = false,
}) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      direction={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      gap={'10px'}
      sx={{ cursor: disabled ? 'default' : 'pointer', ...customStyle }}
      onClick={onClick}
    >
      {leftIcon}
      {hideTextOnMobile && isSmDown ? null : (
        <Typography
          variant={variant}
          sx={{
            textDecoration: 'underline',
            ...(disabled && {
              // color: '#EC0E00',
              color: '#E2001A',
              opacity: 0.2,
            }),
            whiteSpace: 'nowrap',
          }}
          color="primary"
        >
          {msg}
        </Typography>
      )}
      {rightIcon}
    </Stack>
  );
};

export const ProfileBaseInfoCard = styled(Stack)(({ theme }) => ({
  width: '100%',
  padding: '20px',
  border: '1px solid #777',
  backgroundColor: '#eee',
  display: 'flex',
  gap: '10px',
  flexDirection: 'row',
  [`@media (min-width:${theme.breakpoints.values.lg}px)`]: {
    maxWidth: '800px',
  },
}));

export const SdmTextfieldV5 = styled(TextField)({
  width: '100%',
  '& .MuiFormControl-root': {
    width: '95%',
  },
  '& label.Mui-focused': {
    color: `black`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `black`,
  },
  '& .MuiInput-underline.Mui-disabled:before': {
    borderBottomStyle: `solid`,
    borderBottomColor: '#919EAB',
  },
  '& .MuiInput-underline:before': {
    borderBottom: `2px solid black`,
  },
  '& .MuiInputBase-input': {
    fontFamily: 'Suisse-Intl',
    // fontSize: 16,
  },
  '& .MuiFormLabel-root': {
    fontFamily: 'Suisse-Intl',
    color: `black`,
    // fontSize: 12,
  },
});
